import { render } from "./InputDateSimple.vue?vue&type=template&id=0f83924e"
import script from "./InputDateSimple.vue?vue&type=script&lang=js"
export * from "./InputDateSimple.vue?vue&type=script&lang=js"

import "./InputDateSimple.vue?vue&type=style&index=0&id=0f83924e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__